import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import useFlash from "go-alert/AlertMessage";
import handleError from "go-app/services/errors";
import { UnprocessableEntity } from "go-core/api/exceptions";
import { useConfirmation } from "go-form/components/ModalConfirm";
import { selectOrganization } from "go-security/services/organizations/selectors";

export const useForceChangeToNegativeStockState = () => {
	const confirmation = useConfirmation();
	const { addFlash } = useFlash();
	const {
		more: { states_constraint_type },
	} = useSelector(selectOrganization);
	const { t } = useTranslation();

	const displayConfirmationModal = async (confirmationMessage: string) => {
		await confirmation({
			title: t("common.word.confirmation", { ns: "lib" }),
			message: confirmationMessage,
		});
	};

	const doubleConfirmationActionHandler = async (
		actionCallback: (forceCloseWithNegativeStockState: boolean) => Promise<void>,
		firstConfirmationMessage?: string,
		customFinallyBlock?: () => void
	) => {
		try {
			if (firstConfirmationMessage) {
				await displayConfirmationModal(firstConfirmationMessage);
			}
			await actionCallback(false);
		} catch (err) {
			let notEnoughInStockErrorOccurred = false;
			if (err instanceof UnprocessableEntity) {
				notEnoughInStockErrorOccurred = err.errors.some((error) => error.message === "not_enough_in_stock");
			}

			if (notEnoughInStockErrorOccurred && states_constraint_type === "WARNING") {
				try {
					await displayConfirmationModal(t("common.action.force_close_with_negative_stock_state"));
					await actionCallback(true);
				} catch (nestedError) {
					handleError.alert(nestedError, addFlash);
				}
			} else handleError.alert(err, addFlash);
		} finally {
			if (customFinallyBlock) {
				customFinallyBlock();
			}
		}
	};

	return doubleConfirmationActionHandler;
};
